import { render, staticRenderFns } from "./IconCustomizeMenus.vue?vue&type=template&id=0789d0b7&"
import script from "./IconCustomizeMenus.vue?vue&type=script&lang=js&"
export * from "./IconCustomizeMenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0789d0b7')) {
      api.createRecord('0789d0b7', component.options)
    } else {
      api.reload('0789d0b7', component.options)
    }
    module.hot.accept("./IconCustomizeMenus.vue?vue&type=template&id=0789d0b7&", function () {
      api.rerender('0789d0b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconCustomizeMenus.vue"
export default component.exports